import api from '../../../../App/socket';

export const getCapBrands = () => api.send({
    api: 'module',
    module: 'Leads',
    classMethod: 'GetCapData',
    options: {
        method: 'getBrands',
    },
}).then(response => response).catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/cap_requests/get_cap_brands_request.js